import styled from 'styled-components';

import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';

export const CardStyled = styled(Card)`
  background-color: #675ce7;
  max-width: 950px;
`;
CardStyled.displayName = 'CardStyled';

export const CardActionAreaStyled = styled(CardActionArea)`
  align-items: stretch;
  display: flex;

  @media only screen and (max-width: 540px) {
    flex-direction: column;
  }
`;
CardActionAreaStyled.displayName = 'CardActionAreaStyled';

export const CardContentStyled = styled(CardContent)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 32px;

  @media only screen and (max-width: 540px) {
    padding: 16px;
  }
`;
CardContentStyled.displayName = 'CardContentStyled';

export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 32px;

  @media only screen and (max-width: 540px) {
    display: none;
  }
`;
DescriptionWrapper.displayName = 'DescriptionWrapper';

export const ImageBackgroundStyled = styled.div`
  align-items: center;
  background: rgba(6, 6, 6, 0.25);
  display: flex;
  padding: 16px;
`;
ImageBackgroundStyled.displayName = 'ImageBackgroundStyled';
